import { Control, Controller } from 'react-hook-form';

import { TimeInput } from '@/components';

export interface FormTimeInputProps {
  control: Control<any>;
  name: string;
  placeholder: string;
  disabled?: boolean;
  required?: boolean;
}

const FormTimeInput = ({
  control,
  name,
  placeholder,
  disabled = false,
  required = false,
}: FormTimeInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TimeInput
          {...field}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          error={!!error}
          errorInfo={error?.message}
        />
      )}
    />
  );
};

export default FormTimeInput;
